SupportProgressBarView = require('../progress_bar_view')
SupportV1SelectDifferentOrderMenuView = require('../order_related/v1_select_different_order_menu_view')
SupportCurrentOrderView = require('../order_related/current_order_view')
SupportMainContentWrapperView = require('../main_content_view')
SupportStepActionsView = require('../step_actions_view')
SupportUtilsHelper = require('../../helpers/utils')
SharedWidgetLayoutView = require('../../../../shared/frontend/views/widget_layout_veiw')
SupportHelpWizardController = require('../../helpWizardController')
Backbone = require 'backbone'
Backbone.$ = $
SupportStepOneActionsTemplate = require('../../../step_one_actions.html.mustache')

class SupportV1StepOneView extends Backbone.View
  className: 'v1 step-one'

  initialize: ->
    @id = 1
    @I18nScope = 'modules.support'
    Groupon.Support.Email = {}
    @progressBar = new SupportProgressBarView
    @selectDifferentOrderMenu = new SupportV1SelectDifferentOrderMenuView
    @currentOrder = new SupportCurrentOrderView
    @stepActions = new SupportStepActionsView
      template: SupportStepOneActionsTemplate
    @mainContentWrappper = new SupportMainContentWrapperView

  resetContentModelParams: ()->
    if Groupon.Support.ContentModel?
      Groupon.Support.ContentModel.escalateToMerchant = false
      Groupon.Support.ContentModel.isRefundEligible = false

  renderOrderDetails: ()->
    window.hideFooterLinks()
    @resetContentModelParams()
    @mainContentWrappper.render( (contentWrapper)=>
      @renderProgressBar(contentWrapper)
      @renderSelectDifferentOrderMenu(contentWrapper)
      @renderCurrentOrder(contentWrapper)
    )
    @$el.html(@mainContentWrappper.el)
    @renderStepActions()
    @hideComponents()

  renderProgressBar: (contentWrapper)->
    @progressBar.render()
    contentWrapper.append(@progressBar.el)
    contentWrapper.append("<br>")

  renderSelectDifferentOrderMenu: (contentWrapper)->
    @selectDifferentOrderMenu.render()
    contentWrapper.append(@selectDifferentOrderMenu.el)

  renderCurrentOrder: (contentWrapper)->
    @currentOrder.render()
    contentWrapper.append(@currentOrder.el)

  renderStepActions: ->
    @stepActions.render()
    @$el.append(@stepActions.el)

  hideComponents: ->
    SupportUtilsHelper.hideFloatingBoldChat()
    SharedWidgetLayoutView.hideWidgets()

  close: ->
    @$el.empty()

  render: (params = {}) ->
    {order} = params
    showLoading(@$el)
    unless Groupon.Support.OrdersCollection.hasOrders()
      @initOrdersFetch()
    else if order
      @getOrderDetails(order)
    else
      orderSummary = Groupon.Support.currentOrdersFilter.getFirstOrder()
      @getOrderDetails(orderSummary)

  initOrdersFetch:() ->
    _successCb = (orders) =>
      @myGrouponSuccessCallback(orders)
    _errorCb = () =>
      @loadOrderErrorCallback()
    if Groupon.Support.currentOrdersFilter.iterator.hasNext()
      Groupon.Support.currentOrdersFilter.iterator.next(_successCb, _errorCb)
    else
      _errorCb()

  myGrouponSuccessCallback: (orders) ->
    if orders?.length > 0
      if window.orderIdFromMyGroupons?
        _successCb = (orderDetails) =>
          @getOrderMetaData(orderDetails)
        _errorCb = () =>
          @loadOrderErrorCallback()
        Groupon.Support.OrderModel.getOrderDetailsForMygrouponsOrderId(_successCb, _errorCb)
      else
        order = Groupon.Support.currentOrdersFilter.getFirstOrder()
        @getOrderDetails(order)
    else if Groupon.Support.currentOrdersFilter.iterator.hasNext()
      @initOrdersFetch()
    else
      @loadOrderErrorCallback()

  getOrderDetails: (orderSummary) ->
    _successCb = (orderDetails) =>
      @getOrderMetaData(orderDetails)
    params =
      order: orderSummary
    Groupon.Support.OrderModel.getOrderDetails params, _successCb, _successCb

  getOrderMetaData: (orderDetails) ->
    SupportHelpWizardController.changeCurrentOrder(orderDetails)
    if orderDetails?
      _successCb = (order) =>
        @handleNormalAndMyGrouponsFlow(order)
      _errorCb = () =>
        @loadOrderErrorCallback()
      Groupon.Support.MAXINDEX = 3
      Groupon.Support.ORDER_NOT_LISTED = false
      Groupon.Support.NOT_ORDER_RELATED = false
      params =
        order: orderDetails
      Groupon.Support.OrderModel.getMetadata(params, _successCb, _errorCb)

  handleNormalAndMyGrouponsFlow: (order)->
    if window.selectOrderFromMygroupons
      SupportHelpWizardController.stepTwo()
    else
      @renderOrderDetails()

  loadOrderErrorCallback: ->
    SupportHelpWizardController.abruptStepTwoFlow()

module.exports = SupportV1StepOneView
